import { writable } from 'svelte/store';
export const idPageHome = "home";
export const idPageDecouvrir = "decouvrir";
export const idPageAccompagner = "accompagner";
export const idPageActualites = "actualites";
export const idPageContacts = "contacts";
export const idPageMentionsLegales = "mentionslegales";
export const idPageActu = "actualite";
export const idPageProjets = "projets";
export const idPageCharte = "charte";
export const idPageBudget2025 = "budget2025";
export const namePageHome = "Home";
export const namePageDecouvrir = "découvrir le dispositif";
export const namePageAccompagner = "se faire accompagner";
export const namePageActualites = "les actualités";
export const namePageContacts = "contacts";
export const namePageMentionsLegales = "mentions légales";
export const namePageActu = "actualité";
export const namePageProjets = "découverte des projets PTCE";
export const namePageCharte = "charte des PTCE";
export const namePageBudget2025 = "Budget2025 : mobilisation générale";
export const storeFirstDisplayHome = writable(true);
